<template>
	<div
		class="g-block-rich-text g-block-body-padding"
		:class="{
			'g-block-rich-text--edit': editable,
			'is-active': editable && active,
			'g-block-rich-text--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-rich-text__content"
			v-html="displayContent"
			@click="onContentClick"
		></div>
		<div
			v-if="!data.content || data.content === '<p><br></p>' || data.content === '<br>'"
			class="g-block-rich-text__placeholder"
		>编辑富文本内容</div>
	</div>
</template>

<script>
	import { reSignRichTextMedia } from '../../utils/qiniuMedia.js';

	export default {
		name: 'GBlockRichText',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select', 'update'],
		computed: {
			displayContent() {
				if (!this.data.content || this.data.content === '<p><br></p>' || this.data.content === '<br>') {
					return '';
				}
				// H5 渲染时对所有七牛图片/视频链接重新签名，彻底解决存入的签名过期问题
				return this.h5 ? reSignRichTextMedia(this.data.content) : this.data.content;
			},
		},
		methods: {
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				// 点击即触发编辑（打开弹窗）
				this.$emit('select');
			},
			onContentClick(e) {
				// 安全：H5 渲染时禁止外链跳转，仅展示文本与样式
				const anchor = e.target?.closest?.('a');
				if (anchor) {
					e.preventDefault();
					e.stopPropagation();
				}
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../Body/shared/bodyEditShell.less';

	.g-block-rich-text {
		.body-block-edit-shell();
		cursor: pointer;
		position: relative;

		&--edit:hover {
			border-color: #d9d9d9;
		}
	}

	.g-block-rich-text__content {
		display: block;
		width: 100%;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.75;
		color: #333;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		min-height: 40px;
		:deep(p) {
			margin: 0 0 0.5em;
			&:last-child {
				margin-bottom: 0;
			}
		}

		:deep(ul),
		:deep(ol) {
			margin: 0 0 0.5em;
			padding-left: 1.5em;
		}

		:deep(img) {
			max-width: 100%;
			height: auto;
		}

		:deep(a) {
			color: #1890ff;
			text-decoration: none;
		}

		:deep(strong),
		:deep(b) {
			font-weight: 700;
		}

		:deep(em),
		:deep(i) {
			font-style: italic;
		}

		:deep(u) {
			text-decoration: underline;
		}

		:deep(h1) { font-size: 1.8em; font-weight: 700; }
		:deep(h2) { font-size: 1.5em; font-weight: 700; }
		:deep(h3) { font-size: 1.25em; font-weight: 700; }
		:deep(h4) { font-size: 1.1em; font-weight: 700; }
	}

	.g-block-rich-text__placeholder {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #d9d9d9;
		font-size: 14px;
		pointer-events: none;
		white-space: nowrap;
	}

	.g-block-rich-text--h5 {
		.g-block-rich-text__content {
			font-size: 0.28rem;
			min-height: 0.8rem;
		}
		.g-block-rich-text__placeholder {
			font-size: 0.28rem;
		}
	}
</style>
